// 此文件由脚本自动生成，请勿直接修改。
// This file was generated automatically by a script. Please do not modify it directly.

import { SwitchTokens } from './type';

const switchTokens: SwitchTokens = {
  switchFontSize: 'Font-14',
  switchFontColor: 'Neutral-text-4',
  switchPaddingX: 'Spacing-2',
  switchPaddingY: 'Spacing-2',
  switchCircleSize: 'Size-9',
  switchCircleFill: 'Neutral-text-1',
  switchCircleShadow: 'Shadow-3',
  switchWidth: 'Size-21',
  switchTextPaddingLeft: 'Spacing-6',
  switchTextPaddingRight: 'Spacing-4',
  switchSmallFontSize: 'Font-12',
  switchSmallPaddingX: 'Spacing-2',
  switchSmallPaddingY: 'Spacing-2',
  switchSmallCircleSize: 'Size-6',
  switchSmallWidth: 'Size-14',
  switchSmallTextPaddingLeft: 'Spacing-4',
  switchSmallTextPaddingRight: 'Spacing-2',
  switchLargeFontSize: 'Font-16',
  switchLargePaddingX: 'Spacing-2',
  switchLargePaddingY: 'Spacing-2',
  switchLargeCircleSize: 'Size-12',
  switchLargeWidth: 'Size-27',
  switchBackgroundColor: 'Neutral-fill-4',
  switchDisabledBackgroundColor: 'Neutral-fill-3',
  switchDisabledCircleCheckedFill: 'Brand-1',
  switchDisabledCircleUncheckedFill: 'Neutral-fill-2',
  switchDisabledFontColor: 'Neutral-text-2',
  switchLoadingBackgroundColor: 'Neutral-fill-2',
  switchLoadingCircleFill: 'Neutral-fill-3',
  switchLoadingFontColor: 'Neutral-text-2',
  switchCheckedBackgroundColor: 'Brand-6',
  switchCheckedCircleFill: 'Neutral-fill-1',
  switchCheckedFontColor: 'Neutral-text-1',
  switchCheckedDisabledBackgroundColor: 'Brand-3',
  switchCheckedDisabledCircleFill: 'Neutral-fill-1',
  switchCheckedDisabledFontColor: 'Neutral-text-1',
  switchCheckedLoadingBackgroundColor: 'Brand-3',
  switchCheckedLoadingCircleFill: 'Brand-3',
  switchCheckedLoadingFontColor: 'Neutral-text-1',
};

export default switchTokens;
